import React from 'react'
import Select from 'react-select'

const stylesControl = (baseStyle) => {
  return {
    ...baseStyle,
    border: '3px solid rgba(255, 255, 255, 0.87)',
    borderRadius: 10,
    background: 'none',
    width: '100%',
  }
}

const stylesSingleValue = (baseStyle) => {
  return {
    ...baseStyle,
    color: ' rgba(255, 255, 255, 0.87)',
  }
}

const stylesOption = (baseStyle, state) => {
  return {
    ...baseStyle,
    backgroundColor: state.isSelected ? "#fd8d32b5" : "none",
    borderRadius: 10,
  }
}

function CustomSelect(props) {
  return (
    <Select {...props} styles={{
      control: stylesControl,
      singleValue: stylesSingleValue,
      container: (baseStyle) => ({...baseStyle, width: '100%'}),
      menu: (style) => ({...style, background: '#1b1b1b', borderRadius: 10, border: '1px'}),
      input: (style) => ({...style, color: ' rgba(255, 255, 255, 0.87)' }),
      option: stylesOption,
    }}/>
  )
}

export default CustomSelect